import { mapGetters, mapActions } from 'vuex'

export const Computed = {
  ...mapGetters('requestCancellation', ['cancelTokens']),
}

export const Methods = mapActions('requestCancellation', ['cancelPendingRequests'])
